// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"73793f92","115":"ced0737b"}[chunkId] + ".chunk.js";
};